<template>
  <div class="Fuell-Table--row Fuell-Table--row-exportsHistory">
    <div class="Fuell-Table--item"><span class="ml-1">{{exportHistory.createdAt | formatTheDate('short_date_year_long_time', true)}} </span></div>
    <div class="Fuell-Table--item"><span class="ml-1">{{mappingConfigurationName(exportHistory.exportSetting.mappingConfiguration)}}</span></div>
    <div class="Fuell-Table--item"><span class="ml-1">{{exportFieldMappingName(exportHistory.exportSetting.exportFieldMapping)}}</span></div>
    <div class="Fuell-Table--item Fuell-Table--item-html">
      <p
        v-for="(translatedFilter, index) in translateFilters(exportHistory)"
        :key="index"
      >
        {{translatedFilter}}
      </p>
    </div>
    <div class="Fuell-Table--item"><span class="ml-1">{{exportHistory.exportSetting.exportFieldMapping.exportFormat.format}}</span></div>
    <div class="Fuell-Table--item"><span :class="transactionStatusClass(exportHistory)">{{ translateStatus(exportHistory)}}</span></div>
    <div class="Fuell-Table--item"><span
        class=" w-100 link clickable"
        :disabled="isDownloadingMedia"
        @click="downloadExportItem(exportHistory.exportHistory)"
        v-t="{path:'ACTION_DOWNLOAD'}"
        v-if="showDownloadLink(exportHistory.exportHistory)"
      ></span></div>

  </div>
</template>

<script>
import { REVIEW_STATUS } from '@/constants/reviewStatus'
import { EXPORT_TRANSACTION_REPORT_EXTENSION } from '@/utils/constants'
import { getResourceFromAws } from '@/shared/_api'
export default {
  name: 'ExportedTableRow',
  props: {
    exportHistory: {
      type: Object
    }
  },
  data () {
    return {
      isDownloadingMedia: false,
      showConfirmModal: false
    }
  },
  methods: {
    mappingConfigurationName (mappingConfiguration) {
      return mappingConfiguration?.name || ''
    },
    exportFieldMappingName (exportFieldMapping) {
      return exportFieldMapping?.name || ''
    },
    translateFilters (exportHistory) {
      const filters = exportHistory.filters?.filter
      let translatedFilters = []
      if (filters.isCompleted) {
        translatedFilters.push(this.$t('export_exportation_flow_translate_filters_completed'))
      }
      if (filters['reviewStatus.code']) {
        if (filters['reviewStatus.code'] && filters['reviewStatus.code']?.indexOf(REVIEW_STATUS.CANCELLED) !== -1 && filters['reviewStatus.code']?.indexOf(REVIEW_STATUS.APPROVED) !== -1) {
          translatedFilters.push(`${this.$t('export_exportation_flow_translate_filters_status')} ${this.$t('export_exportation_flow_translate_filters_status_CANCELLED')} ${this.$t('export_exportation_flow_translate_filters_status_APPROVED')}`)
        } else {
          if (filters['reviewStatus.code'] && filters['reviewStatus.code']?.indexOf(REVIEW_STATUS.CANCELLED) !== -1) {
            translatedFilters.push(`${this.$t('export_exportation_flow_translate_filters_status')} ${this.$t('export_exportation_flow_translate_filters_status_CANCELLED')}`)
          }
          if (filters['reviewStatus.code'] && filters['reviewStatus.code']?.indexOf(REVIEW_STATUS.APPROVED) !== -1) {
            translatedFilters.push(`${this.$t('export_exportation_flow_translate_filters_status')} ${this.$t('export_exportation_flow_translate_filters_status_APPROVED')}`)
          }
        }
      }
      if (filters.isPersonalExpense) {
        translatedFilters.push(this.$t('export_exportation_flow_translate_filters_personal_expense'))
      }
      if (filters['date[']) {
        if (filters['date[before]'] && filters['date[after]']) {
          translatedFilters.push(`${this.$t('export_exportation_flow_translate_filters_date')} ${filters['date[before]']} ${filters['date[after]']}`)
        } else {
          if (filters['date[before]']) {
            translatedFilters.push(`${this.$t('export_exportation_flow_translate_filters_date')} ${filters['date[before]']}`)
          }
          if (filters['date[after]']) {
            translatedFilters.push(`${this.$t('export_exportation_flow_translate_filters_date')} ${filters['date[after]']}`)
          }
        }
      }
      if (filters['type.code']) {
        translatedFilters.push(`${this.$t('export_exportation_flow_translate_filters_entity_' + filters['type.code'])}`)
      } else {
        translatedFilters.push(this.$t('export_exportation_flow_translate_filters_entity_ALL'))
      }
      if (filters.budget) {
        translatedFilters.push(`${this.$t('export_exportation_flow_translate_filters_budget')} ${filters.budget.name}`)
      }
      if (filters.users) {
        translatedFilters.push(`${this.$t('export_exportation_flow_translate_filters_user')} ${filters.users.map(item => `${item.firstName} ${item.lastName}`)}`)
      }

      return translatedFilters
    },
    showDownloadLink (exportHistory) {
      if (!exportHistory) return false
      return exportHistory.status?.code === 'COMPLETE'
    },
    async downloadExportItem (exportHistory) {
      if (this.isDownloadingMedia) return
      this.isDownloadingMedia = true
      try {
        // const { data } = await getMediaUrl(exportHistory.media.id)
        // const resource = await getUrlResource(data[0])
        const resource = await getResourceFromAws(exportHistory.media.id)
        const exportData = URL.createObjectURL(resource.data)
        const downloadLink = document.createElement('a')
        downloadLink.href = exportData
        downloadLink.download = `Export_GG_${this.$moment.utc(exportHistory.createdAt).format('DD-MM-YYY')}${EXPORT_TRANSACTION_REPORT_EXTENSION}`
        downloadLink.click()
        URL.revokeObjectURL(exportData)
      } catch (error) {
        console.error(error)
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transactions_download_export_history_error' })
      } finally {
        this.isDownloadingMedia = false
      }
    },
    transactionStatusClass (exportHistoryStatus) {
      if (exportHistoryStatus.exportHistory?.status?.code === 'PENDING') {
        return 'text-info'
      }
      if (exportHistoryStatus.exportHistory?.status?.code === 'PROCESSING' || exportHistoryStatus.exportHistory?.status?.code === 'ERROR') {
        return 'text-warning'
      }
      return 'text-success'
    },
    translateStatus (exportHistoryStatus) {
      if (exportHistoryStatus.exportHistory?.status) {
        return this.$t(`transactions_export_history_status__${exportHistoryStatus.exportHistory?.status?.code}`)
      }
      return ''
    }
  }
}
</script>
<style lang="scss">
.Fuell-Table--row.Fuell-Table--row-exportsHistory {
  grid-template-columns: 160px 160px 160px 350px 100px 180px 80px !important;

  .link {
    color: var(--text-link);
  }
}
.Fuell-Table--item-html {
  align-items: flex-start;
  white-space: normal;
  overflow: auto;
  text-overflow: unset;
  flex-direction: column;
  p {
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
}
</style>
